import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "../constants/brand";

const OWNER = "Ionica-Bogdan Murariu";
const PARTNER = "Ciprian Marius Marisescu";

const CONTENT = {
  widerruf: {
    title: "Widerrufsbelehrung",
    sections: [
      {
        h: "Widerrufsrecht",
        p: [
          "Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.",
          "Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Ware in Besitz genommen haben bzw. hat.",
          `Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (${BRAND.name}, ${OWNER}, ${BRAND.address}, Telefon: ${BRAND.phone}, E-Mail: ${BRAND.email}) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das untenstehende Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.`,
          "Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.",
        ],
      },
      {
        h: "Folgen des Widerrufs",
        p: [
          "Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich etwaiger Lieferkosten, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben.",
          "Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere Zeitpunkt ist.",
          "Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf unterrichten, an uns zurückzusenden oder zu übergeben. Sie tragen die unmittelbaren Kosten der Rücksendung der Waren.",
          "Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen ist.",
        ],
      },
      {
        h: "Ausnahmen vom Widerrufsrecht",
        p: [
          "Das Widerrufsrecht besteht nicht bei Verträgen zur Erbringung von Dienstleistungen mit fest vereinbartem Termin (Transportdienstleistungen, Werkstatttermine), wenn wir die Leistung vollständig erbracht haben und Sie ausdrücklich zugestimmt haben, dass wir vor Ablauf der Widerrufsfrist mit der Leistung beginnen.",
        ],
      },
      {
        h: "Muster-Widerrufsformular",
        p: [
          `(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück an: ${BRAND.name}, ${OWNER}, ${BRAND.address}, E-Mail: ${BRAND.email})`,
          "— Hiermit widerrufe(n) ich/wir den von mir/uns abgeschlossenen Vertrag über den Kauf der folgenden Waren / die Erbringung der folgenden Dienstleistung:",
          "— Bestellt am / erhalten am: ____________",
          "— Bestellnummer (Bestell-Nr.): ____________",
          "— Name des/der Verbraucher(s): ____________",
          "— Anschrift des/der Verbraucher(s): ____________",
          "— Datum und Unterschrift (nur bei Mitteilung auf Papier): ____________",
        ],
      },
    ],
  },
  impressum: {
    title: "Impressum",
    sections: [
      {
        h: "Angaben gemäß § 5 DDG",
        p: [
          `${BRAND.name}`,
          `Inhaber: ${OWNER}`,
          `In Zusammenarbeit mit: ${PARTNER}`,
          BRAND.address,
          "Deutschland",
        ],
      },
      {
        h: "Kontakt",
        p: [`Telefon: ${BRAND.phone}`, `E-Mail: ${BRAND.email} · ${BRAND.emailInfo}`],
      },
      {
        h: "Umsatzsteuer",
        p: [
          "Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG:",
          "DE 357042965",
        ],
      },
      {
        h: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
        p: [`${OWNER}`, BRAND.address],
      },
      {
        h: "EU-Streitschlichtung",
        p: [
          "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr",
          "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
        ],
      },
      {
        h: "Bildnachweis",
        p: [
          "Fahrzeugfoto „Opel Movano“ (Fahrzeugflotte): Alexander-93, Wikimedia Commons, lizenziert unter CC BY-SA 4.0 (creativecommons.org/licenses/by-sa/4.0).",
          "Übrige Fotografien: Unsplash (unsplash.com/license).",
        ],
      },
    ],
  },
  datenschutz: {
    title: "Datenschutzerklärung",
    sections: [
      {
        h: "1. Verantwortlicher",
        p: [
          `${BRAND.name} · ${OWNER}`,
          BRAND.address,
          `Telefon: ${BRAND.phone} · E-Mail: ${BRAND.email} · ${BRAND.emailInfo}`,
        ],
      },
      {
        h: "2. Welche Daten wir verarbeiten",
        p: [
          "Bei einer Transportbuchung verarbeiten wir: Name, Telefonnummer, E-Mail-Adresse, Abhol- und Zieladresse sowie Angaben zur Ladung (Art, Palettenzahl, Gewicht).",
          "Bei einem Werkstatttermin: Name, Telefonnummer, E-Mail-Adresse, Fahrzeuginformationen und gewünschte Leistung.",
          "Bei einer Bestellung im Shop: Name, Telefonnummer, E-Mail-Adresse und die bestellten Produkte.",
          "Bei Nutzung des Kontaktformulars: Name, E-Mail-Adresse und Ihre Nachricht.",
        ],
      },
      {
        h: "3. Zweck und Rechtsgrundlage",
        p: [
          "Die Verarbeitung erfolgt zur Vertragserfüllung und vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO), zur Erfüllung gesetzlicher Pflichten (Art. 6 Abs. 1 lit. c DSGVO) sowie auf Grundlage unseres berechtigten Interesses an der Bereitstellung und Verbesserung unseres Angebots (Art. 6 Abs. 1 lit. f DSGVO).",
        ],
      },
      {
        h: "4. Zahlungsabwicklung über PayPal",
        p: [
          "Für die Zahlungsabwicklung im Shop nutzen wir PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxemburg. Bei der Bezahlung werden die für die Transaktion erforderlichen Daten an PayPal übermittelt (Art. 6 Abs. 1 lit. b DSGVO). Es gilt die Datenschutzerklärung von PayPal: https://www.paypal.com/de/webapps/mpp/ua/privacy-full",
        ],
      },
      {
        h: "5. Karten- und Routendienste",
        p: [
          "Für die Adresssuche und Streckenberechnung nutzen wir OpenStreetMap (Nominatim) und OSRM. Bei der Nutzung werden Ihre IP-Adresse und die eingegebenen Adressen an die Server dieser Dienste übertragen. Es gelten die Datenschutzbestimmungen der OpenStreetMap Foundation: https://wiki.osmfoundation.org/wiki/Privacy_Policy",
        ],
      },
      {
        h: "6. E-Mail-Versand",
        p: [
          "Für den Versand von Buchungs- und Bestellbestätigungen nutzen wir den E-Mail-Dienst Resend. Dabei werden Ihre E-Mail-Adresse und der Inhalt der Bestätigung über diesen Dienst verarbeitet.",
        ],
      },
      {
        h: "7. Cookies",
        p: [
          "Diese Website verwendet ausschließlich ein technisch notwendiges Cookie für die Anmeldung im Admin-Bereich. Es findet kein Tracking und keine Analyse zu Werbezwecken statt.",
        ],
      },
      {
        h: "8. Speicherdauer",
        p: [
          "Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke oder gesetzliche Aufbewahrungspflichten erforderlich ist.",
        ],
      },
      {
        h: "9. Ihre Rechte",
        p: [
          "Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen die Verarbeitung Ihrer Daten. Wenden Sie sich hierzu an: " + BRAND.email,
          "Außerdem haben Sie das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.",
        ],
      },
      {
        h: "10. Besucherstatistik",
        p: [
          "Wir erheben eine anonyme Besucherstatistik (Seitenaufrufe und tägliche Besucherzahlen). Dabei werden keine Cookies gesetzt und keine IP-Adressen gespeichert. Die Zuordnung erfolgt ausschließlich über einen täglich wechselnden Zufallswert, der keine Rückschlüsse auf Ihre Person zulässt.",
          "Rechtsgrundlage ist unser berechtigtes Interesse an der Verbesserung unseres Angebots (Art. 6 Abs. 1 lit. f DSGVO).",
        ],
      },
    ],
  },
  agb: {
    title: "Allgemeine Geschäftsbedingungen",
    sections: [
      {
        h: "§ 1 Geltungsbereich",
        p: [
          `Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen ${BRAND.name}, Inhaber ${OWNER}, ${BRAND.address} (nachfolgend „wir") und unseren Kunden über Transportdienstleistungen, Werkstattleistungen und den Kauf von Produkten aus unserem Shop.`,
        ],
      },
      {
        h: "§ 2 Vertragsschluss",
        p: [
          "Transporte und Werkstatttermine werden über das Buchungsformular angefragt. Der Vertrag kommt mit unserer Bestätigung per E-Mail oder Telefon zustande.",
          "Im Shop stellt die Produktbeschreibung ein Angebot dar. Mit Abschluss des Bestellvorgangs und der Zahlung geben Sie eine verbindliche Bestellung ab; der Vertrag kommt mit unserer Bestellbestätigung zustande.",
        ],
      },
      {
        h: "§ 3 Preise und Zahlung",
        p: [
          "Transporte werden mit 1,50 € netto pro gefahrenem Kilometer berechnet (zzgl. 19 % MwSt.). Der im Buchungsformular angezeigte Endpreis inkl. MwSt. ist verbindlich.",
          "Alle Preise verstehen sich zuzüglich der gesetzlichen Umsatzsteuer von 19 %. Gegenüber Verbrauchern weisen wir Endpreise inklusive Umsatzsteuer aus. USt-IdNr.: DE 357042965",
          "Die Zahlung im Shop erfolgt über PayPal. Der Kaufpreis ist sofort fällig.",
        ],
      },
      {
        h: "§ 4 Transportdienstleistungen",
        p: [
          "Der Kunde ist verpflichtet, bei der Buchung vollständige und zutreffende Angaben zu Ladung, Gewicht und Adressen zu machen.",
          "Vom Transport ausgeschlossen sind Gefahrgüter, verderbliche Waren ohne entsprechende Vereinbarung sowie gesetzlich verbotene Güter.",
          "Nach jeweils 10 gebuchten und durchgeführten Transporten ist der 11. Transport kostenlos (Treuebonus).",
        ],
      },
      {
        h: "§ 5 Werkstatttermine",
        p: [
          "Vereinbarte Werkstatttermine (z. B. Radwechsel, Wuchten, Wasserstoff-Motorreinigung) sind verbindlich. Eine kostenfreie Absage ist bis 24 Stunden vor dem Termin möglich.",
        ],
      },
      {
        h: "§ 6 Widerrufsrecht für Shop-Bestellungen",
        p: [
          "Verbrauchern steht bei Fernabsatzverträgen über Waren ein Widerrufsrecht von 14 Tagen ab Erhalt der Ware zu. Zur Ausübung genügt eine eindeutige Erklärung an: " + BRAND.email,
          "Für Dienstleistungen mit fest vereinbartem Termin (Transport, Werkstatt) erlischt das Widerrufsrecht bei vollständiger Leistungserbringung, wenn Sie ausdrücklich zugestimmt haben, dass wir vor Ablauf der Widerrufsfrist mit der Leistung beginnen.",
        ],
      },
      {
        h: "§ 7 Gewährleistung",
        p: [
          "Es gilt das gesetzliche Mängelhaftungsrecht.",
        ],
      },
      {
        h: "§ 8 Haftung",
        p: [
          "Wir haften unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit. Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden begrenzt. Im Übrigen ist die Haftung ausgeschlossen.",
        ],
      },
      {
        h: "§ 9 Schlussbestimmungen",
        p: [
          "Es gilt deutsches Recht. Gerichtsstand ist – soweit zulässig – Karlsruhe.",
          "Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.",
        ],
      },
    ],
  },
};

export default function LegalPage({ kind }) {
  const content = CONTENT[kind];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [kind]);

  return (
    <div data-testid={`legal-page-${kind}`} className="min-h-screen bg-[#0A0E14] text-slate-200">
      <header className="border-b border-white/5">
        <div className="max-w-3xl mx-auto px-5 py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logo-mark.png" alt={`${BRAND.name} Logo`} className="w-9 h-9 rounded-lg object-cover" />
            <div>
              <div className="font-semibold text-white text-sm">{BRAND.name}</div>
              <div className="text-[10px] tracking-[0.25em] text-slate-500 font-mono-tech">{BRAND.tagline}</div>
            </div>
          </div>
          <a
            data-testid="legal-back-link"
            href="/"
            className="flex items-center gap-2 text-xs text-slate-400 hover:text-cyan-300 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 py-12 lg:py-16">
        <h1 className="text-4xl font-bold text-white mb-10">{content.title}</h1>
        <div className="space-y-8">
          {content.sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${kind}-${i}`} className="rounded-2xl border border-white/5 bg-white/[0.02] p-6">
              <h2 className="text-lg font-semibold text-cyan-300 mb-3">{s.h}</h2>
              {s.p.map((para, j) => (
                <p key={j} className="text-sm text-slate-300 leading-relaxed mb-2 last:mb-0">{para}</p>
              ))}
            </section>
          ))}
        </div>
        <p className="mt-10 text-xs text-slate-600">Stand: Juli 2026</p>
      </main>
    </div>
  );
}
